<template>
  <section class="myCenterCommon__userContent__2fHEF route-fade-enter-done">
    <div class="myCenterCommon__users_layout__title__3CoQ0"><h3>返水记录</h3></div>
    <div class="myCenterCommon__users_layout__params__2DfEC">
      <div class="myCenterCommon__check_wrap__3bM7H">
        <div class="myCenterCommon__users_layout__params_item__MYZdv myCenterCommon__fl__waaJH" style="width: 35%">
          <div class="myCenterCommon__users_params__label__3y-Q5">选择游戏：</div>
          <div>
            <el-select v-model="api_type" placeholder="请选择平台" @change="changApiType">
              <el-option v-for="(item, index) in dogameLis" :key="index" :label="item.name" :value="item.platname"> </el-option>
            </el-select>
          </div>
        </div>
        <div class="myCenterCommon__users_layout__params_item__MYZdv myCenterCommon__fr__3TeIF">
          <div class="myCenterCommon__users_params__label__3y-Q5">时间选择：</div>
          <el-radio-group v-model="date"  @change="changeDate">
            <el-radio-button :label="1">今日</el-radio-button>
            <el-radio-button :label="2">一周内</el-radio-button>
            <el-radio-button :label="3">半月内</el-radio-button>
            <el-radio-button :label="4">一月内</el-radio-button>
          </el-radio-group>
        </div>
        <button @click="lingqu" data-label="投注记录-查询" class="index__Button__It0J4 index__Button3__1Pn-Q" style="width: 113px; height: 40px; position: absolute; left: 120px; top: -60px">一键领取</button>
        <div style="width: 200px; line-height: 40px; height: 40px; position: absolute; left: 300px; top: -60px">
          可领取返水金额：<span style="font-weight: bold; color: red">{{ nojisuan }}</span>
        </div>
        <div style="width: 200px; line-height: 40px; height: 40px; position: absolute; left: 500px; top: -60px">
          总计领取返水金额：<span style="font-weight: bold; color: red">{{ jisuan }}</span>
        </div>
      </div>
    </div>
    <el-table :data="fanshuiList" style="width: 100%">
      <el-table-column prop="gamename" label="游戏名称"> </el-table-column>
      <el-table-column prop="money" label="返水金额"> </el-table-column>
      <el-table-column prop="state" label="状态">
        <template slot-scope="scope">
          {{ scope.row.state == 0 ? '待领取' : '已领取' }}
        </template></el-table-column
      >
      <el-table-column prop="created_at" label="返水时间"> </el-table-column>
      <el-table-column prop="state" label="领取时间">
        <template slot-scope="scope">
          {{ scope.row.state == 0 ? '暂未领取' : scope.row.updated_at }}
        </template></el-table-column
      >
    </el-table>
    <el-pagination v-if="fanshuishowData.total" style="margin: 20px 0 0px 120px" @current-change="getfanshui" :current-page.sync="page" :page-size="10" layout="prev, pager, next" :total="fanshuishowData.total"></el-pagination>
  </section>
</template>
<script>
export default {
  name: 'fanshui',
  data() {
    return {
      date: 4,
      fanshuiList: [],
      fanshuishowData: {},
      jisuan: 0,
      nojisuan: 0,
      page: 1,
      dogameLis: [],
      api_type: '',
    };
  },
  created() {
    let that = this;
    that.getdogame();
    that.getfanshui();
  },
  methods: {
    changApiType() {
      let that = this;
      that.page = 1;
      that.getfanshui();
    },
    getdogame() {
      let that = this;

      that.$apiFun.post('/api/balancelist', {}).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.showTost(res.message);
        }
        if (res.code == 200) {
          that.dogameLis = res.data;
          that.dogameLis.unshift({ name: '全平台', platname: '' });
        }
      });
    },
    changeDate() {
      let that = this;
      that.page = 1;
      that.getfanshui();
    },
    // 获取返水记录
    getfanshui() {
      let that = this;
      that.$parent.showLoading();
      let info = {
        date: that.date,
        page: that.page,
        api_type: that.api_type,
        type: '',
      };
      that.$apiFun
        .post('/api/getfanshui', info)
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.fanshuiList = res.data.list.data;
            that.fanshuishowData = res.data.list;
            that.jisuan = res.data.jisuan;
            that.nojisuan = res.data.nojisuan;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    lingqu() {
      let that = this;
      let fanshui = that.nojisuan;
      if (fanshui <= 0) {
        that.$parent.showTost(0, '暂无领取额度！');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/dofanshui', {})
        .then(res => {
          console.log(res);
          that.$parent.getUserInfo();
          that.$parent.showTost(1, res.message);
          that.getfanshui();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
// @import '../../../static/css/announcement_modal.css';
@import '../../../static/css/Transfer_81ba8019.f1b60e17.css';
</style>



// WEBPACK FOOTER //
// src/components/mine/fanshui.vue